import React from 'react';
import { Text } from '../../text/text.component';
import { useModalContext } from '../provider/modal.provider';

export const ConfirmationText: React.FC<React.PropsWithChildren<{ children: React.ReactNode }>> = ({ children }) => {
  const { descriptionId } = useModalContext();
  return (
    <Text id={descriptionId} textAlign='left'>
      {children}
    </Text>
  );
};
